export const Spinner = () => {
  return (
    <div role="status">
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/60">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-color border-b-transparent" />
      </div>
    </div>
  );
};
